exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indexPagination__pagination___2j10I {\n  margin-top: 20px; }\n\n.indexPagination__total___2_2DN {\n  float: right;\n  margin-top: 25px; }\n  @media screen and (max-width: 576px) {\n    .indexPagination__total___2_2DN {\n      float: unset;\n      text-align: center; } }\n", ""]);

// exports
exports.locals = {
	"pagination": "indexPagination__pagination___2j10I",
	"total": "indexPagination__total___2_2DN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/IndexPagination/indexPagination.scss
// module id = 1941
// module chunks = 6